import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface ReferralItem {
  referrer_name: string;
  referee_name: string;
  referee_email_masked: string;
  referee_phone_masked: string;
  submitted_at: string;
  status: string;
  attributed_quote_id?: string;
  attributed_amount: number;
}

export function useReviewsReferrals(limit = 20) {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["reviews", "referrals", limit],
    queryFn: async () => {
      const res = await fetch(`/api/cockpit/reviews/referrals?limit=${limit}`, {
        headers,
      });
      if (!res.ok) throw new Error("Reviews referrals failed");
      return res.json() as Promise<{ items: ReferralItem[] }>;
    },
    staleTime: 5 * 60_000,
  });
}
